module.exports = __webpack_public_path__ + "static/img/banner-2.55abb89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner-2.png
// module id = RgXL
// module chunks = 1